<template>
  <div class="page">
    <smart-block
      link="https://otahuhumainstreet.co.nz/news/"
      heading="Otahuhu News"></smart-block>
    <smart-block
      heading="Promotions"></smart-block>
    <smart-block
      heading="Events"></smart-block>
  </div>
</template>

<script>
import SmartBlock from "../../components/SmartBlock.vue";
import OtahuhuNewsIcon from "@/assets/icons/balloon.svg";

export default {
  components: { SmartBlock },
  data() {
    return {
      OtahuhuNewsIcon
    }
  }
}
</script>
